import { memo } from 'react';

const PanelLabel = memo(({ panelLabel, filteredData }) => {
  return panelLabel?.(filteredData ?? []);
});

export default PanelLabel; 